import { ChangeEvent} from "react";
import styled from "styled-components";
interface PayDateModalProps{
    isOpen:boolean,
    date:string
    onChange:(e: ChangeEvent<HTMLSelectElement>) => void,
    onCancelClick:() => void,
    onConfirmClick:() => void,
}
const PayDateModal = ({isOpen, date, onCancelClick, onChange, onConfirmClick}:PayDateModalProps) => {

    if(!isOpen){
        return null;
    }

    const renderOption = () => {
        const list = []
        for(let i = 1; i <= 31; i++){
            list.push(<option value={i}>{i}</option>)
        }
        return list;
    }

    return(
        <Container>
        <Box>
            <Title>납부 설정</Title>
            <Contents>
                <Select name="method" onChange={onChange} value={date}>
                    {renderOption()};
                </Select>
            </Contents>
            <ButtonWrap>
                <ButtonCancel onClick={onCancelClick}>취소</ButtonCancel>
                <Button onClick={onConfirmClick}>저장</Button>
            </ButtonWrap>
        </Box>
    </Container>
    )
}

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const Box = styled.div`
  background-color: white;
  width: 420px;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  animation-name: fadeInUp;
  animation-duration: 1s;

  h2 {
    margin-bottom: 0px;
  }
`;

const Title = styled.span`
    font-size: 24px;
`
const Contents = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
`

const Select = styled.select`
    width: 100%;
    padding: 12px;
    font-size: 16px;
`

const ButtonWrap = styled.div`
    display: flex;
    gap: 24px;
`

const ButtonCancel = styled.button`
  height: 45px;
  padding: 0 47px;
  background-color: white;
  border: 1px solid #434343;
  color: #df0000;
  border-radius: 52px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: 0.3s;
`;



const Button = styled.button`
  height: 45px;
  padding: 0 47px;
  background-color: #df0000;
  color: white;
  border: none;
  border-radius: 52px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: 0.3s;
`;



export default PayDateModal;